import React from "react";

export default function RatingIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"28"||props}
      height={"28"||props}
      fill={"none"||props}
      viewBox={"0 0 28 28"||props}
      {...props}
    >
      <rect width={"28"||props} height={"28" ||props}fill={"#EFF0F4"||props} rx={"2"||props}></rect>
      <path
        stroke={"#292D32"||props}
        strokeLinecap={"round"||props}
        strokeLinejoin={"round"||props}
        strokeWidth={"1.15"||props}
        d="M15.21 8.01l1.231 2.485c.168.346.616.678.994.741l2.233.374c1.428.24 1.764 1.284.735 2.315l-1.736 1.75c-.294.296-.455.868-.364 1.277l.497 2.167c.392 1.715-.511 2.378-2.016 1.482l-2.093-1.25c-.378-.225-1-.225-1.385 0l-2.093 1.25c-1.498.896-2.408.226-2.016-1.482l.497-2.167c.09-.41-.07-.98-.364-1.277l-1.736-1.75c-1.022-1.03-.693-2.075.735-2.315l2.233-.374c.37-.064.819-.395.987-.741l1.232-2.484c.671-1.348 1.763-1.348 2.428 0z"
      ></path>
    </svg>
  );
}